import { currentUser, ensureUserIsLoggedIn, load } from "scrivito"
import * as Scrivito from "scrivito"
import { JRAPIClient } from "shared/api/http-clients/JRAPIClient"
import { SchakoAPIClient } from "shared/api/http-clients/SchakoAPIClient"
import { getWindow } from "shared/lib/getWindow"
import { UserInfo } from "shared/types/UserInfo"

import { setLoginStatus } from "widgets/auth-provider/model/login-store"
import { setUserInfo } from "widgets/auth-provider/model/user-info-store"

function getUserInfo(
  user: ReturnType<typeof Scrivito.currentUser>
): UserInfo | null {
  if (!user) {
    return null
  }

  return {
    id: user?.id(),
    name: user?.name(),
    email: user?.email(),
    picture: user?.picture()
  }
}

export async function verifyLogin(options?: { onLoginExpired?: () => void }) {
  const [scrivitoUserInfo, schakoAPIToken, jrAPIToken] = await Promise.all([
    load(() => currentUser()),
    SchakoAPIClient.getToken(),
    JRAPIClient.getToken()
  ])

  // user is logged in but scrivito is not aware of the login
  if (!scrivitoUserInfo && schakoAPIToken && jrAPIToken) {
    ensureUserIsLoggedIn()
  }

  // login has expired
  if (scrivitoUserInfo && (!schakoAPIToken || !jrAPIToken)) {
    // open login overlay or redirect directly to idp (can we get chosen idp?)
    setUserInfo(null)
    options?.onLoginExpired?.()
    getWindow()?.location.reload()
  }

  // user is logged in
  if (scrivitoUserInfo && schakoAPIToken && jrAPIToken) {
    setLoginStatus(true)
    const userInfo = getUserInfo(scrivitoUserInfo)
    setUserInfo(userInfo)
  } else {
    // user is not logged in
    setLoginStatus(false)
    setUserInfo(null)
  }

  return { userInfo: scrivitoUserInfo, token: schakoAPIToken, jrAPIToken }
}
